import { render, staticRenderFns } from "./OurCompanyOrganizationalCharts.vue?vue&type=template&id=43fd80b4&scoped=true&"
import script from "./OurCompanyOrganizationalCharts.vue?vue&type=script&lang=js&"
export * from "./OurCompanyOrganizationalCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd80b4",
  null
  
)

export default component.exports